import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import {
	NbUserModule,
	NbMenuModule,
	NbThemeModule,
	NbCardModule,
	NbSelectModule,
	NbInputModule,
	NbIconModule,
	NbContextMenuModule,
	NbMenuService,
	NbLayoutModule,
	NbTabsetModule,
	NbListModule,
	NbSidebarModule,
	NbSidebarService,
	NbSpinnerModule,
	NbAccordionModule
} from '@nebular/theme';
import { TermsComponent } from './components/terms/terms.component';
import { AntiFraudRoutingModule } from './anti-fraud.routing';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { ScenarioOneComponent } from './components/dashboard/scenario-one/scenario-one.component';
import { ScenarioOneResults } from './components/dashboard/scenario-one/scenario-one-results/scenario-one-results.component';
import { ScenarioTwoComponent } from './components/dashboard/scenario-two/scenario-two.component';
import { ScenarioTwoResultsComponent } from './components/dashboard/scenario-two/scenario-two-results/scenario-two-results.component';
import { ScenarioThreeComponent } from './components/dashboard/scenario-three/scenario-three.component';
import { ScenarioFourComponent } from './components/dashboard/scenario-four/scenario-four.component';
import { ScenarioFiveComponent } from './components/dashboard/scenario-five/scenario-five.component';
import { ScenarioSixComponent } from './components/dashboard/scenario-six/scenario-six.component';
import { ScenarioSevenComponent } from './components/dashboard/scenario-seven/scenario-seven.component';
import { ScenarioEightComponent } from './components/dashboard/scenario-eight/scenario-eight.component';
import { ScenarioNineComponent } from './components/dashboard/scenario-nine/scenario-nine.component';
import { ScenarioTenComponent } from './components/dashboard/scenario-ten/scenario-ten.component';
import { AboutProjectComponent } from './components/about-project/about-project.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ScenarioThreeResultsComponent } from './components/dashboard/scenario-three/scenario-three-results/scenario-three-results.component';
import { ScenarioFourthResultsComponent } from './components/dashboard/scenario-four/scenario-fourth-results/scenario-fourth-results.component';
import { ScenarioFiveResultsComponent } from './components/dashboard/scenario-five/scenario-five-results/scenario-five-results.component';

@NgModule({
	declarations: [
		FooterComponent,
		HeaderComponent,
		TermsComponent,
		DashboardComponent,
		ScenarioOneComponent,
		ScenarioOneResults,
		ScenarioTwoComponent,
		ScenarioTwoResultsComponent,
		ScenarioThreeComponent,
		ScenarioFourComponent,
		ScenarioFiveComponent,
		ScenarioSixComponent,
		ScenarioSevenComponent,
		ScenarioEightComponent,
		ScenarioNineComponent,
		ScenarioTenComponent,
		AboutProjectComponent,
		NotFoundComponent,
		ScenarioThreeResultsComponent,
		ScenarioFourthResultsComponent,
		ScenarioFiveResultsComponent
	],
	imports: [
		CommonModule,
		AntiFraudRoutingModule,
		NbCardModule,
		NbSelectModule,
		NbInputModule,
		NbIconModule,
		NbThemeModule.forRoot({ name: 'default' }),
		NbMenuModule.forRoot(),
		NbUserModule,
		NbLayoutModule,
		NbContextMenuModule,
		NbTabsetModule,
		NbListModule,
		NbSidebarModule,
		NbMenuModule,
		NbContextMenuModule,
		FormsModule,
		ReactiveFormsModule,
		NbSpinnerModule,
		NbAccordionModule
	],
	providers: [NbMenuService, NbSidebarService, NbSpinnerModule],
	exports: [FooterComponent, HeaderComponent]
})
export class AntiFraudModule {}
